import { Badge } from '@/components/ui/badge';
import { getReferralTypeConfig } from '@/utils/referralHelpers';

interface ReferralTypeCellProps {
  type: string | null;
  size?: 'sm' | 'md';
}

/**
 * Componente para mostrar el tipo de relación de un referido
 * con badge visual (color, ícono y label)
 */
export function ReferralTypeCell({ type, size = 'md' }: ReferralTypeCellProps) {
  const config = getReferralTypeConfig(type);

  return (
    <div className="flex items-center gap-1.5">
      <span className={size === 'sm' ? 'text-base' : 'text-lg'}>{config.icon}</span>
      <Badge
        variant="outline"
        className={`${config.bgColor} ${config.color} border-0 ${
          size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-3 py-1'
        }`}
      >
        {config.label}
      </Badge>
    </div>
  );
}
